// extracted by mini-css-extract-plugin
export const howItWorksSection = "howItWorks-module--howItWorksSection--153f5";
export const circleRight = "howItWorks-module--circleRight--EIGjp";
export const circleLeft = "howItWorks-module--circleLeft--1O0xW";
export const sectionContainer = "howItWorks-module--sectionContainer--20s7M";
export const row = "howItWorks-module--row--HNJpd";
export const col = "howItWorks-module--col--DS56f";
export const appStore = "howItWorks-module--appStore--2WJis";
export const googlePlay = "howItWorks-module--googlePlay--HUWrt";